import {Action} from "redux";
import {
    StartPollingMessageRoomsByClientResponse,
} from "../response/message_room_response";

export enum ClientMessageRoomsActionType {
    REQUEST_START_POLLING_MESSAGE_ROOMS = "CLIENT__MESSAGE_ROOMS_REQUEST_START_POLLING_MESSAGE_ROOMS",
    CALLBACK_START_POLLING_MESSAGE_ROOMS = "CLIENT__MESSAGE_ROOMS_CALLBACK_START_POLLING_MESSAGE_ROOMS",
    REQUEST_STOP_POLLING_MESSAGE_ROOMS = "CLIENT__MESSAGE_ROOMS_REQUEST_STOP_POLLING_MESSAGE_ROOMS",
}

export interface IRequestStartPollingMessageRoomsByClientMessageRoomsAction extends Action {
    type: ClientMessageRoomsActionType.REQUEST_START_POLLING_MESSAGE_ROOMS;
}

export interface ICallbackStartPollingMessageRoomsByClientMessageRoomsAction extends Action {
    type: ClientMessageRoomsActionType.CALLBACK_START_POLLING_MESSAGE_ROOMS;
    isSuccess: boolean;
    item?: StartPollingMessageRoomsByClientResponse;
    error?: any;
}

export interface IRequestStopPollingMessageRoomsByClientMessageRoomsAction extends Action {
    type: ClientMessageRoomsActionType.REQUEST_STOP_POLLING_MESSAGE_ROOMS;
}

export type ClientMessageRoomsAction =
    IRequestStartPollingMessageRoomsByClientMessageRoomsAction |
    ICallbackStartPollingMessageRoomsByClientMessageRoomsAction |
    IRequestStopPollingMessageRoomsByClientMessageRoomsAction
    ;

export interface IClientMessageRoomsActionCreator {

    requestStartPollingMessageRoomsAction(): IRequestStartPollingMessageRoomsByClientMessageRoomsAction;

    callbackStartPollingMessageRoomsAction(
        isSuccess: boolean,
        item?: StartPollingMessageRoomsByClientResponse,
        error?: any,
    ): ICallbackStartPollingMessageRoomsByClientMessageRoomsAction;

    requestStopPollingMessageRoomsAction(): IRequestStopPollingMessageRoomsByClientMessageRoomsAction;
}

class ActionCreator implements IClientMessageRoomsActionCreator {

    public requestStartPollingMessageRoomsAction = (): IRequestStartPollingMessageRoomsByClientMessageRoomsAction => {
        return {
            type: ClientMessageRoomsActionType.REQUEST_START_POLLING_MESSAGE_ROOMS,
        };
    };

    public callbackStartPollingMessageRoomsAction = (
        isSuccess: boolean,
        item?: StartPollingMessageRoomsByClientResponse,
        error?: any,
    ): ICallbackStartPollingMessageRoomsByClientMessageRoomsAction => {
        return {
            type: ClientMessageRoomsActionType.CALLBACK_START_POLLING_MESSAGE_ROOMS,
            isSuccess,
            item,
            error,
        };
    };

    public requestStopPollingMessageRoomsAction = (): IRequestStopPollingMessageRoomsByClientMessageRoomsAction => {
        return {
            type: ClientMessageRoomsActionType.REQUEST_STOP_POLLING_MESSAGE_ROOMS,
        };
    };
}

export const createClientMessageRoomsActionCreator = (): IClientMessageRoomsActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_message_rooms_action.ts